<template>
	<div>
		<md-content>
			<div class="md-layout md-gutter">
			
		       <div class="md-layout-item md-xsmall-size-100">
			      	<md-field>
				      <label>请输入APPID/ID/产品名称</label>
				      <md-input v-model="pdata.kw"></md-input>
				    </md-field>
		       </div>
		       
		        <div class="md-layout-item md-xsmall-size-100">
			       	<md-field>
			          <label for="status">请选择广告状态</label>
			          <md-select v-model="pdata.status" name="status" id="status">
	                      <md-option value="fight-club" :value="noText">请选择广告状态</md-option>
	                      <md-option value="fight-club" :value="'1'" >启用</md-option>
	                      <md-option value="fight-club" :value="'0'" >禁用</md-option>
			          </md-select>
			        </md-field>
		        </div>
		  
		        <div class="md-layout-item md-xsmall-size-100">
			       	<md-field>
			          <label for="movie">请选择广告类型</label>
			          <md-select v-model="pdata.type" name="type" id="type">
			          	<md-option value="fight-club" :value="noText" >请选择广告类型</md-option>
			            <md-option value="fight-club" :value="item[1]" v-for="item,index in config">{{item[0]}}</md-option>
			          </md-select>
			        </md-field>
		        </div>
		    </div> 
		    <md-content>
		    	
		    	 <md-table v-model="plist" v-if="plist.length>0"  @md-selected="onSelect"> 
			      <md-table-toolbar>
			        <h1 class="md-title">广告位</h1>
			          <div class="md-layout md-gutter">
						<div class="md-layout-item md-xsmall-size-25">
							<md-button class="md-raised" @click.native="addBanner">新增</md-button>
						</div>
						<div class="md-layout-item md-xsmall-size-25">
							<md-button class="md-raised md-primary">启用</md-button>
						</div>
						<div class="md-layout-item md-xsmall-size-25">
							<md-button class="md-raised md-accent">禁用</md-button>
						</div>
						<div class="md-layout-item md-xsmall-size-25">
							<md-button class="md-raised md-accent">删除</md-button>
						</div>
		    		</div>
			      </md-table-toolbar>

			      
			
			      <md-table-row slot="md-table-row" slot-scope="{ item }"  md-selectable="multiple" md-auto-select>
			        <md-table-cell md-label="ID" md-sort-by="id" md-numeric>{{ item.id }}</md-table-cell>
			        <md-table-cell md-label="小程序名称" md-sort-by="name">{{ item.name }}</md-table-cell>
			        <md-table-cell md-label="广告位名称" md-sort-by="email">{{item.name+'-'+item.type_name}}</md-table-cell>
			        <md-table-cell md-label="广告位类型" md-sort-by="gender">{{item.type_name}}</md-table-cell>
			        <md-table-cell md-label="广告位尺寸" md-sort-by="title">{{item.width+'X'+item.height}}</md-table-cell>
			        <md-table-cell md-label="支持设备" md-sort-by="title">{{item.device}}</md-table-cell>
			        <md-table-cell md-label="启用时间" md-sort-by="title">{{item.create_time}}</md-table-cell>
			        <md-table-cell md-label="禁用时间" md-sort-by="title">{{item.end_time}}</md-table-cell>
			        <md-table-cell md-label="广告位状态" md-sort-by="title">{{item.status==1?'正常':'禁用'}}</md-table-cell>
			      </md-table-row>
			    </md-table>
			   <!--<md-table  v-if="plist.length>0" >
			      <md-table-row >
			        
			        <md-table-head>ID</md-table-head>			
					<md-table-head>小程序名称</md-table-head>
					<md-table-head>广告位名称</md-table-head>
					<md-table-head>广告位类型</md-table-head>
					<md-table-head>广告位尺寸</md-table-head>
					<md-table-head>支持设备</md-table-head>
					<md-table-head>启用时间</md-table-head>
					<md-table-head>禁用时间</md-table-head>
					<md-table-head>广告位状态</md-table-head>
	
			      </md-table-row>
			
			      <md-table-row v-for="item,index in plist" md-selectable="multiple" md-auto-select>
			      	<md-table-cell>{{item.id}}</md-table-cell>
			        <md-table-cell>{{item.name}}</md-table-cell>
			        <md-table-cell>{{item.name+'-'+item.type_name}}</md-table-cell>
			        <md-table-cell>{{item.type_name}}</md-table-cell>
			        <md-table-cell>{{item.width+'X'+item.height}}</md-table-cell>
			        <md-table-cell>{{item.device}}</md-table-cell>
			        <md-table-cell>{{item.create_time}}</md-table-cell>
			        <md-table-cell>{{item.end_time}}</md-table-cell>
			        <md-table-cell>{{item.status==1?'正常':'禁用'}}</md-table-cell>
			      </md-table-row>
			      
				</md-table>-->
			    
			    <md-table  v-else>
			      <md-table-row>
			        <md-table-head>暂无信息</md-table-head>
			      </md-table-row>
				</md-table>
				
				<div class="md-layout md-gutter md-alignment-center">
				    <div class="md-layout-item md-medium-size-10 md-small-size-25 md-xsmall-size-25">
				    	 <md-button class="md-dense md-primary" @click.native="goPrev">上一页</md-button>
				    </div>
				    <div class="md-layout-item md-medium-size-80 md-small-size-50 md-xsmall-size-50">
				    	 <md-field>
				          <label >选择页码</label>
				          <md-select v-model="pdata.page" name="page" id="page">
				            <md-option :value="item" v-for="item in maxPage">{{item}}</md-option>
				          </md-select>
				        </md-field>
				    </div>
				    <div class="md-layout-item md-medium-size-10 md-small-size-25 md-xsmall-size-25">
				    	 <md-button class="md-dense md-primary" @click.native="goNext">下一页</md-button>
				    </div>
			 	 </div>
			 </md-content>

		    
		    
		</md-content>
		
		<md-dialog :md-active.sync="editDialog">
			
		  <form novalidate  @submit.prevent="validateUser">
		  <md-content style="padding: 10px;">
	      <md-dialog-title>{{isAdd==true?"新增广告位":"编辑广告位"}}</md-dialog-title>
	     
		  <div class="md-layout md-gutter md-alignment-center">
		  	
		  	<div class="md-layout-item md-medium-size-10 md-small-size-50 md-xsmall-size-100">
		  	    <md-field :class="getValidationClass('issued_app_id')">
		          <label for="issued_app_id">请选择小程序名称</label>
		          <md-select v-model="form.issued_app_id" name="issued_app_id" id="issued_app_id">
		            <md-option :value="item.id" v-for="item,index in applist">{{item.name}}</md-option>
		          </md-select>
		          <span class="md-error">请选择小程序名称</span>
		        </md-field>
		  	</div>
		  	
		  	<div class="md-layout-item md-medium-size-10 md-small-size-50 md-xsmall-size-100">
		  		<md-field :class="getValidationClass('type')">
		          <label for="type">请选择广告位类型</label>
		          <md-select v-model="form.type" name="type" id="type">
		            <md-option :value="item[1]" v-for="item,index in config">{{item[0]}}({{item[1]}})</md-option>
		          </md-select>
		          <span class="md-error">请选择广告位类型</span>
		        </md-field>
		  	</div>
		  	
		  	<div class="md-layout-item md-medium-size-10 md-small-size-50 md-xsmall-size-100">
		  		<md-field :class="getValidationClass('device')">
		          <label for="device">广告系统</label>
		          <md-select v-model="form.device" name="device" id="device">
		            <md-option value="all" >all</md-option>
		            <md-option value="ios" >ios</md-option>
		            <md-option value="android" >android</md-option>
		          </md-select>
		          <span class="md-error">请选择广告系统</span>
		        </md-field>
		  	</div>
		  	
		  	<div class="md-layout-item md-xsmall-size-100">
		      	<md-field :class="getValidationClass('width')">
			      <label>输入广告尺寸-宽度</label>
			      <md-input v-model="form.width"></md-input>
			      <span class="md-error">请输入广告尺寸-宽度</span>
			    </md-field>
			    <md-field :class="getValidationClass('height')">
			      <label>输入广告尺寸-高度</label>
			      <md-input v-model="form.height"></md-input>
			       <span class="md-error">输入广告尺寸-高度</span>
			    </md-field>
	       </div>
	       
		  </div>
		  
		  <md-progress-bar md-mode="indeterminate" v-if="sending" />
	      <md-dialog-actions>
	        <md-button class="md-primary" @click="editDialog = false">取消</md-button>
	        <md-button type="submit" class="md-primary" :disabled="sending">保存</md-button>
	        <!--<md-button class="md-primary" type="submit" :disabled="sending">保存</md-button>-->
	      </md-dialog-actions>
	       </md-content>
	       </form>
	    </md-dialog>
	    
	     <md-dialog-alert
	      :md-active.sync="isSuc"
	      :md-content="successMessage"
	      md-confirm-text="知道了!" />
	      
	      <md-dialog-alert
	      :md-active.sync="isErr"
	      :md-content="ErrorMessage"
	      md-confirm-text="知道了!" />
	
	   
	  </div>
	</div>
</template>

<script>
	import { sconfig,sadlist,saddad,seditad, saddp, spstatus, splog, seditp, scopy } from "../api/api";
    import { required, minLength, between } from 'vuelidate/lib/validators';

	export default {
		 data() {
		 	return{
		 		pdata: {
			        page: 1,
			        perpage: 10,
			        theme: "",
			        status: "",
			        kw: "",
			        sort_field: "",
			        sort_by: "",
			        placement:"",
			        type:"",
			      },
			      maxPage:1,
			      plist: [],
			      sText: "请选择广告位状态",
      			  tText: "请选择广告位类型",
			      pText:"请选择产品投放位置",
			      option: [], //投放位置配置
			      config:[],
			      noText:'',
			      editDialog: false ,
			      isAdd: false,
			      applist:[],
			      form: { issued_app_id: "", device: "", type: "",width:"",height:"" },
			      sending:false,
			      isSuc:false,
			      isErr:false,
			      successMessage:'',
			      ErrorMessage:'',
			      selected:[],
			      cP: {
			        space_id: "",
			        status: "1",
			        log: ""
			      }, //修改选中的产品状态,批量修改状态
			      
			 	}
		 	  
		 },
		 validations: {
	      form: {
	        issued_app_id: {
	          required,
	        },
	        device: {
	          required,
	        },
	        type: {
	          required,
	        },
	        width: {
	          required
	        },
	        height: {
	          required,
	        }
	       }
	      },
		   watch: {
		    "pdata.type": {
		      handler(n, o) {
		        this.pdata.type=n;
		        this.pdata.page=1;
		        this.getList();
		      },
		      deep: true
		      // immediate: true
		    },
		     "pdata.status": {
		      handler(n, o) {
		        this.pdata.status=n;
		        this.pdata.page=1;
		        this.getList();
		      },
		      deep: true
		      // immediate: true
		    },
		    "pdata.kw": {
		      handler(n, o) {
		        this.pdata.kw=n;
		        this.pdata.page=1;
		        this.getList();
		      },
		      deep: true
		      // immediate: true
		    },
		    "pdata.page": {
		      handler(n, o) {
		        this.pdata.page=n;
		        this.getList();
		      },
		      deep: true
		      // immediate: true
		    }
		  },
		 methods:{
		 	onSelect (items) {
		        this.selected = items
		      },
		    changeStatus(isSingle, s) {
    	
		    	this.$prompt("请输入编辑原因", "提示", {
		        confirmButtonText: "确定",
		        cancelButtonText: "取消",
		        inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
		        inputErrorMessage: "内容不能为空"
		      }).then(({ value }) => {
		  	
				      if (!isSingle && this.selectProduct.length == 0) {
				        this.$message.error("请先选择需要批量操作的数据");
				        return;
				      }
				      if (isSingle) {
				        this.cP.space_id = s.id;
				        this.cP.status = s.status == 1 ? "0" : "1";
				      } else {
				        this.cP.status = s;
				      }
				
		
				      this.cP.log = value
				      
				      sadstatus(this.cP, this.$cookie.getCookie("login")).then(res => {
				        if (res.code == 200) {
				          this.getList();
				          this.$message({ message: this.cP.log + "成功", type: "success" });
					        }
					      });
		
		      });
		    	
		 
		      
		    },
		 	addBanner(){
		 		 this.form = { issued_app_id: "", device: "all", type: "float",width:"",height:"" };
			     this.editDialog = true;
			     this.isAdd = true;
		 	},
		 	submit() {
		 		
		          if (this.isAdd) {
		            saddad(this.form, this.$cookie.getCookie("login")).then(res => {
		              if (res.code == 200) {
		              	  this.isSuc=true;
		              	  this.successMessage='新增广告位成功';
		          
		                this.getList();
		                this.editDialog = false;
		              } else {
		              	this.isErr=true;			     
			      		this.ErrorMessage='添加失败';
//		                this.$message.error(res.msg);
		              }
		            });
		          } else {
		            // this.$prompt("请输入编辑原因", "提示", {
		            //   confirmButtonText: "确定",
		            //   cancelButtonText: "取消",
		            //   inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
		            //   inputErrorMessage: "内容不能为空"
		            // }).then(({ value }) => {
		              this.form.log = '编辑内容';
		              seditad(this.form, this.$cookie.getCookie("login")).then(res => {
		                if (res.code == 200) {
		                  this.$message({ message: "编辑广告位成功", type: "success" });
		                  this.getList();
		                  this.editDialog = false;
		                } else {
		                  this.$message.error(res.msg);
		                }
		              });
		            // });
		          }
			        
			     
			    },
		 	getValidationClass (fieldName) {
		 	
		        const field = this.$v.form[fieldName]
		
		        if (field) {
		          return {
		            'md-invalid': field.$invalid && field.$dirty
		          }
		        }
		      },
		 	goDetail(id){
		 		this.$router.push({ path: '/product/detail/'+id })
		 	},
		 	getList() {
		      var p = "";
		      for (var k in this.pdata) {
		        // if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
		        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
		      }
		      			      
		       sadlist(p, this.$cookie.getCookie("login")).then(res => {
		        if (res.code == 200) {
		          this.plist = res.data.list;
		          this.maxPage = res.data.max_page;
		        }
		      });
		    },
			getConfig() {
		      if (this.$store.config) {
		      
		        this.config = this.$store.config.ad_space_type;
		        this.tags = this.$store.config.product_tag;
		        this.applist=this.$store.applist;
		        
		        this.option = this.$store.config.product_placement;
		      } else {
		        setTimeout(() => {
		          this.getConfig();
		        }, 50);
		      }
		    },
		    clearPlacement(s){
		    	this.pdata.placement = '';
		    },
		    goPrev(){
		    	
		    	if(this.pdata.page>1){
		    		this.pdata.page--;
		    	}
		    	
		    },
		    goNext(){
		    	if(this.pdata.page<this.maxPage){
		    		this.pdata.page++;
		    	}
		    	
		    },
		    validateUser () {
		    	debugger;
		        this.$v.$touch()
		
		        if (!this.$v.$invalid) {
		          console.log('保存')
		        }
		    },
		 },
		 mounted() {

		    this.getConfig();
		    this.getList();
		 }
		 
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// ADbanner.vue?76d04c05